import { Outlet } from 'react-router'
import { PrivateScope } from '@/components/ui'
import { PRIVATE_AREA } from '@/lib/analytics'
import { BareContext } from './bare-context'
import { GlobalBanners } from './GlobalBanners'
import { SkipLink } from './SkipLink'

/** Pages without the top bar (auth screens, printable certificates): banners plus the page. */
export function BareLayout() {
  return (
    <div className="flex min-h-dvh flex-col bg-page text-text">
      <SkipLink />
      <GlobalBanners verify={false} />
      <PrivateScope>
        <main id="main-content" tabIndex={-1} className="flex flex-1 flex-col outline-none" {...PRIVATE_AREA}>
          <BareContext.Provider value={true}>
            <Outlet />
          </BareContext.Provider>
        </main>
      </PrivateScope>
    </div>
  )
}
